define("ExternalVendor.Inventory.SS2Model", [
  "SCModel",
  "Utils",
  "AjaxRequestsKiller",
], function (SCModelComponent, Utils, AjaxRequestsKiller) {
  "use strict";

  var SCModel = SCModelComponent.SCModel;

  var ExternalVendorInventorySS2Model =
    function ExternalVendorInventorySS2Model(options) {
      SCModel.call(this);
      var self = this;
      this.recordTypesWithInventory = ["invtpart"];
      this.recordTypesNotPurchasable = ["service"];

      this.options = options || {};

      this.urlRoot = function () {
        return "/app/site/hosting/scriptlet.nl?script=customscript_sdb_sl_man_ext_vendor_inv&deploy=customdeploy_sdb_sl_man_ext_vendor_inv&ns-at=AAEJ7tMQtPvIGE7TbOlrl-C6N4eqjVYBOUu_KWQb_Fmaj5oU-NQ";
      };

      this.parse = function parse(data) {
        var hasError =
          data.details &&
          data.details.type &&
          data.details.type.toLowerCase().indexOf("error") >= 0;

        if (hasError) {
          this.set(
            {
              filteredGroupedLocations: [],
              totalStock: 0,
            },
            {
              silent: true,
              wait: true,
            }
          );
        }

        return data;
      };

      this.getExternalInventory = function (options) {
        if (options.length) {
          var data = { data: JSON.stringify(options), action: "external" };
        } else {
          var locationName = options.locationName || "Fedco";
          var Group = options.group;
          var GroupIdentifier = options.groupIdentifier;
        }

        return this.fetch({
          async: true,
          cache: false,
          killerId: AjaxRequestsKiller.getKillerId(),
          data: data || {
            selectedLocation: locationName,
            Group: Group,
            GroupIdentifier: GroupIdentifier,
            action: "external",
          },
        });
      };

      this.getInternalInventory = function (options) {
        if (options.length) {
          var data = { data: JSON.stringify(options), action: "internal" };
        } else {
          var locationName = options.locationName || "Fedco";
          var sku = options.sku;
          var askedLocations = options.askedLocations;
        }

        return this.save({
          async: true,
          cache: false,
          killerId: AjaxRequestsKiller.getKillerId(),
          data: data || {
            selectedLocation: locationName,
            sku: sku,
            askedLocations: askedLocations,
            action: "internal",
          },
        });
      };

      this.getEarlierShipTime = function () {
        var qty =
          arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        if (!this.get("filteredGroupedLocations")) return;
        var _this$get = this.get("filteredGroupedLocations"),
          external = _this$get.external;
        var obj = {};
        var aux = 0;

        _.find(external, function (data) {
          obj = data;
          aux += data.totalStock;
          if (aux >= qty) return true;
        });

        return obj;
      };

      this.compareETAs = function (time1, time2) {
        var value1 =
          time1.indexOf("Now") != -1
            ? 0
            : time1.indexOf("Days") != -1
              ? 2
              : time1.indexOf("Same") != -1
                ? 1
                : 10;
        var value2 =
          time2.indexOf("Now") != -1
            ? 0
            : time2.indexOf("Days") != -1
              ? 2
              : time2.indexOf("Same") != -1
                ? 1
                : 10;
        var regex = /\d-(\d+)\s*/;
        if (value1 > 1) {
          var match1 = time1.match(regex);
          value1 += Number(match1[1]);
        }
        if (value2 > 1) {
          var match2 = time2.match(regex);
          value2 += Number(match2[1]);
        }
        return value1 - value2 >= 0;
      };

      this.getLatestShipTime = function () {
        var qty =
          arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        if (!this.get("filteredGroupedLocations")) return;
        var _this$get2 = this.get("filteredGroupedLocations"),
          external = _this$get2.external,
          stores = _this$get2.stores;
        if (!stores || !stores.length) {
          if (external.length) return external[external.length - 1].time;
          return;
        }
        var obj = {};
        var lastExt = external.length && external[external.length - 1].time;
        var lastInt = stores[stores.length - 1].time;
        var aux = 0;
        var greater = _.find(stores, function (data) {
          obj = data;
          aux += data.totalStock;
          if (aux >= qty) return true;
        });

        if (!lastExt) return greater ? greater.time : lastInt;

        return greater
          ? this.compareETAs(obj.time, lastExt)
            ? greater.time
            : lastExt
          : this.compareETAs(lastExt, lastInt)
            ? lastExt
            : lastInt;
      };

      this.calculateTotalStock = function (vendors) {
        return _.reduce(
          vendors,
          function (sum, vendor) {
            return (sum += vendor.availableStock);
          },
          0
        );
      };

      this.manageLocations = function () {
        if (Backbone.history.fragment == "cart") return;
        var external =
          (this.get("externalLocationsPDP") &&
            this.get("externalLocationsPDP")[0] &&
            this.get("externalLocationsPDP")[0].filteredGroupedLocations) ||
          [];
        var stores =
          this.get("internalLocationsPDP") &&
          this.get("internalLocationsPDP")[0] &&
          this.get("internalLocationsPDP")[0].filteredGroupedLocations;
        if (!external || !stores) return;
        var locations = external;
        if (stores) locations = locations.concat(stores);

        _.each(
          locations,
          function (location) {
            location.totalStock = this.calculateTotalStock(location.vendors);

            location.price_total = _.reduce(
              location.vendors,
              function (sum, vendor) {
                return (sum += Number(vendor.price));
              },
              0
            );
          },
          this
        );

        this.set(
          "filteredGroupedLocations",
          { external: external, stores: stores },
          { silent: true, wait: true }
        );

        var totalExternalStock = _.reduce(
          external,
          function (total, location) {
            return (total += location.totalStock);
          },
          0
        );
        this.set("totalExternalStock", totalExternalStock, { wait: true });

        var totalStock = _.reduce(
          locations,
          function (total, location) {
            return (total += location.totalStock);
          },
          0
        );
        this.unset("totalStock", { silent: true, wait: true });
        this.set("totalStock", totalStock, { wait: true });
      };

      this.stockMessage = function (
        locationName,
        internalStock,
        externalStock,
        qty,
        shipTime
      ) {
        var hasLocation = !!locationName;
        var totalStock = externalStock + internalStock;

        var formatInstallTime = function formatInstallTime(shipTime) {
          if (shipTime === "Same or Next Business day") {
            return "Ready To Install By Tomorrow!";
          }
          return "Ready To Install within " + shipTime + "!";
        };

        var toShipWording = function toShipWording(text) {
          return text.replace(/Install/g, "Ship");
        };

        var stockMessages = [
          {
            condition: function condition(IS, ES, Q) {
              return Q <= IS;
            },
            message_online: "In stock.",
            message_instore: "In stock.",
          },
          {
            condition: function condition(IS, ES, Q) {
              return IS === 0 && ES === 0;
            },
            message_online: "Contact for availability.",
            message_instore: "Contact for availability.",
          },
        ];

        if (shipTime === "In Stock Available Now" || shipTime === "In Stock Ready To Install Now") {
          stockMessages = stockMessages.concat([
            {
              condition: function condition(IS, ES, Q) {
                return IS === 0 && ES >= Q;
              },

              message_online: Utils.translate(toShipWording(shipTime)),
              message_instore: Utils.translate(shipTime),
            },
            {
              condition: function condition(IS, ES, Q, shipTime) {
                return IS === 0 && ES < Q && shipTime;
              },
              message_online: Utils.translate(
                "$(0) $(1)!",
                externalStock,
                toShipWording(shipTime)
              ),
              message_instore: Utils.translate(
                "$(0) $(1)!",
                externalStock,
                shipTime
              ),
            },
            {
              condition: function condition(IS, ES, Q) {
                return IS > 0 && IS < Q && ES == 0;
              },
              message_online: Utils.translate(
                "$(0) $(1)!",
                internalStock,
                toShipWording(shipTime)
              ),
              message_instore: Utils.translate(
                "$(0) $(1)!",
                internalStock,
                shipTime
              ),
            },
            {
              condition: function condition(IS, ES, Q, shipTime) {
                return IS > 0 && IS < Q && ES >= Q - IS && shipTime;
              },
              message_online: Utils.translate(toShipWording(shipTime)),
              message_instore: Utils.translate(shipTime),
            },
            {
              condition: function condition(IS, ES, Q, shipTime) {
                return IS > 0 && IS < Q && ES < Q - IS && shipTime;
              },
              message_online: Utils.translate(
                "Only $(0) $(1)!",
                totalStock,
                toShipWording(shipTime)
              ),
              message_instore: Utils.translate(
                "Only $(0) $(1)!",
                totalStock,
                shipTime
              ),
            },
          ]);
        } else {
          stockMessages = stockMessages.concat([
            {
              condition: function condition(IS, ES, Q) {
                return IS === 0 && ES >= Q;
              },

              message_online: toShipWording(formatInstallTime(shipTime)),
              message_instore: formatInstallTime(shipTime),
            },
            {
              condition: function condition(IS, ES, Q, shipTime) {
                return IS === 0 && ES < Q && shipTime;
              },
              message_online: Utils.translate(
                "$(0) Available, $(1)",
                externalStock,
                toShipWording(formatInstallTime(shipTime))
              ),
              message_instore: Utils.translate(
                "$(0) Available, $(1)",
                externalStock,
                formatInstallTime(shipTime)
              ),
            },
            {
              condition: function condition(IS, ES, Q) {
                return IS > 0 && IS < Q && ES == 0;
              },
              message_online: Utils.translate("$(0) In stock.", internalStock),
              message_instore: Utils.translate("$(0) In stock.", internalStock),
            },
            {
              condition: function condition(IS, ES, Q, shipTime) {
                return IS > 0 && IS < Q && ES >= Q - IS && shipTime;
              },
              message_online: toShipWording(formatInstallTime(shipTime)),
              message_instore: formatInstallTime(shipTime),
            },
            {
              condition: function condition(IS, ES, Q, shipTime) {
                return IS > 0 && IS < Q && ES < Q - IS && shipTime;
              },
              message_online: Utils.translate(
                "Only $(0) Available, $(1)",
                totalStock,
                toShipWording(formatInstallTime(shipTime))
              ),
              message_instore: Utils.translate(
                "Only $(0) Available, $(1)",
                totalStock,
                formatInstallTime(shipTime)
              ),
            },
          ]);
        }
        if (typeof shipTime === "undefined") shipTime = false;
        var stockMessage = _.find(stockMessages, function (stockMessage) {
          return stockMessage.condition(
            internalStock,
            externalStock,
            qty,
            shipTime
          );
        });
        if (!stockMessage) return "";
        return hasLocation
          ? stockMessage.message_instore
          : stockMessage.message_online;
      };

      this.getStockState = function getStockState(options) {
        var internalStock = options.internalStock,
          externalStock = options.externalStock,
          quantity = options.quantity,
          shipTime = options.shipTime;
        function getDefaultValues(internalStock, externalStock, quantity) {
          return {
            internalStock: internalStock !== undefined ? internalStock : 0,
            externalStock: externalStock !== undefined ? externalStock : 0,
            quantity: quantity !== undefined ? quantity : 1,
          };
        }

        var defaults = getDefaultValues(internalStock, externalStock, quantity);

        internalStock = defaults.internalStock;
        externalStock = defaults.externalStock;
        quantity = defaults.quantity;
        var stockStateData = {
          behavior: "In Stock",
          totalStock: externalStock + internalStock || 0,
          isInStock: true,
          stockDescription: "",
          internalStock: internalStock,
          externalStock: externalStock,
        };

        var totalStock = stockStateData.totalStock || 0;
        if (totalStock === 0) {
          stockStateData.isInStock = false;
          stockStateData.behavior = "Out of Stock";
        } else if (quantity > totalStock) {
          stockStateData.isInStock = false;
        }

        // stockStateData.stockDescription = this.stockMessage(options.locationName, totalStock, quantity);

        // Continue with your code if all are defined
        stockStateData.stockDescription = this.stockMessage(
          options.locationName,
          internalStock,
          externalStock,
          quantity,
          shipTime,
          totalStock
        );
        return stockStateData;
      };

      // this.on('change:externalLocations', this.manageLocations, this);
      this.on("change:internalLocationsPDP", this.manageLocations, this);
    };

  ExternalVendorInventorySS2Model.prototype = Object.create(SCModel.prototype);
  ExternalVendorInventorySS2Model.prototype.constructor =
    ExternalVendorInventorySS2Model;

  ExternalVendorInventorySS2Model.getInstance = function (options) {
    var This = this;
    this.instance = this.instance || new This(options);
    return this.instance;
  };

  return ExternalVendorInventorySS2Model;
});
